import { lazy } from 'react';
import { type RouteObject } from 'react-router-dom';

import { ErrorBoundary } from '../components/ErrorBoundary';
import AdminShell from '../shell/layout/AdminShell';
import { AdminRoute } from './guards';

const ImportedAdminDashboardPage = lazy(() => import('../features/admin/AdminDashboard'));
const ImportedContentWorkbenchPage = lazy(() => import('../features/admin/ContentWorkbench'));
const ImportedAudioQueuePage = lazy(() => import('../features/admin/AudioQueue'));
const ImportedPublishingQueuePage = lazy(() => import('../features/admin/PublishingQueue'));
const ImportedUserManagementPage = lazy(() => import('../features/admin/UserManagement'));
const ImportedAdminAnalyticsPage = lazy(() => import('../features/admin/AdminAnalytics'));
const ImportedAuditLogPage = lazy(() => import('../features/admin/AuditLog'));
const ImportedSettingsTaxonomyPage = lazy(() => import('../features/admin/SettingsTaxonomy'));
const ImportedAdminTranslationsPage = lazy(() => import('../features/admin/AdminTranslations'));
const ImportedAdminFeatureFlagsPage = lazy(() => import('../features/admin/AdminFeatureFlags'));
const ImportedAdminEventCatalogPage = lazy(() => import('../features/admin/AdminEventCatalog'));

export const adminRoutes: RouteObject[] = [
  {
    element: (
      <AdminRoute>
        <ErrorBoundary>
          <AdminShell />
        </ErrorBoundary>
      </AdminRoute>
    ),
    children: [
      {
        path: 'admin',
        element: <ImportedAdminDashboardPage />,
      },
      {
        path: 'admin/content',
        element: <ImportedContentWorkbenchPage />,
      },
      {
        path: 'admin/audio',
        element: <ImportedAudioQueuePage />,
      },
      {
        path: 'admin/publishing',
        element: <ImportedPublishingQueuePage />,
      },
      {
        path: 'admin/users',
        element: <ImportedUserManagementPage />,
      },
      {
        path: 'admin/analytics',
        element: <ImportedAdminAnalyticsPage />,
      },
      {
        path: 'admin/audit',
        element: <ImportedAuditLogPage />,
      },
      {
        path: 'admin/settings',
        element: <ImportedSettingsTaxonomyPage />,
      },
      {
        path: 'admin/translations',
        element: <ImportedAdminTranslationsPage />,
      },
      {
        path: 'admin/feature-flags',
        element: <ImportedAdminFeatureFlagsPage />,
      },
      {
        path: 'admin/events',
        element: <ImportedAdminEventCatalogPage />,
      },
    ],
  },
];
